import axios from 'axios';

import {
  ADD_SPECIALITY,
  FETCH_SPECIALITIES_REQUEST,
  FETCH_SPECIALITIES_SUCCESS,
  FETCH_SPECIALITIES_FAILURE,
  SPECIALITY_DELETE_SUCCESS,
  SPECIALITY_DELETE_FAIL,
} from './types';
import { SPECIALITY_UPDATE_SUCCESS, SPECIALITY_UPDATE_FAIL } from './types';

import { baseURL } from './types'; // Ensure baseURL is exported from types.js or adjust import accordingly

// Add a new speciality
export const addSpeciality = (data) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorSpecialities/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data,
  };

  try {
    const response = await axios(config);
    dispatch({
      type: ADD_SPECIALITY,
      payload: response.data,
    });
    return response;
  } catch (error) {
    console.error('Add speciality failed:', error.response?.data || error.message);
    throw error;
  }
};

export const fetchSpecialities = () => async (dispatch) => {
  dispatch({ type: FETCH_SPECIALITIES_REQUEST });

  try {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await axios.post(
      `${baseURL}/api/appointmentDoctorSpecialities/getall`,
      {},  // empty POST body
      { headers }  // headers go here, not inside data object
    );

    // console.log('API response data:', response.data);  // Check this output

    dispatch({ type: FETCH_SPECIALITIES_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({ type: FETCH_SPECIALITIES_FAILURE, error: error.message });
  }
};



export const editSpeciality = (data) => async (dispatch) => {
  try {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const response = await axios.patch(
      `${baseURL}/api/appointmentDoctorSpecialities/update`,
      data,
      { headers }
    );

    dispatch({
      type: SPECIALITY_UPDATE_SUCCESS,
      payload: { data: response.data }, 
    });
    return response;
  } catch (error) {
    console.error('Edit speciality failed:', error.response?.data || error.message);
    dispatch({ type: SPECIALITY_UPDATE_FAIL, payload: error.message });
    throw error;
  }
};



export const deleteSpeciality = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const response = await axios.delete(
      `${baseURL}/api/appointmentDoctorSpecialities/delete`,
      {
        headers,
        data: { id },  // <-- Send ID inside the body as JSON
      }
    );

    dispatch({
      type: SPECIALITY_DELETE_SUCCESS,
      payload: id,
    });

    return response;
  } catch (error) {
    console.error('Delete speciality failed:', error.response?.data || error.message);
    dispatch({
      type: SPECIALITY_DELETE_FAIL,
      payload: error.message,
    });
    throw error;
  }
};
